import { useMediaQuery } from '@mantine/hooks';
import theme from '@theme';

export default function useIsMobile() {
  return useMediaQuery(`(max-width: ${theme.breakpoints?.sm})`);
}
